import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteOrganisationTeamMemberMutationVariables = Types.Exact<{
  data: Types.DeleteOrganisationTeamInput;
}>;


export type DeleteOrganisationTeamMemberMutation = { __typename?: 'Mutation', deleteTeam: boolean };


export const DeleteOrganisationTeamMemberDocument = gql`
    mutation DeleteOrganisationTeamMember($data: DeleteOrganisationTeamInput!) {
  deleteTeam(data: $data)
}
    `;
export type DeleteOrganisationTeamMemberMutationFn = Apollo.MutationFunction<DeleteOrganisationTeamMemberMutation, DeleteOrganisationTeamMemberMutationVariables>;

/**
 * __useDeleteOrganisationTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationTeamMemberMutation, { data, loading, error }] = useDeleteOrganisationTeamMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteOrganisationTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationTeamMemberMutation, DeleteOrganisationTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationTeamMemberMutation, DeleteOrganisationTeamMemberMutationVariables>(DeleteOrganisationTeamMemberDocument, options);
      }
export type DeleteOrganisationTeamMemberMutationHookResult = ReturnType<typeof useDeleteOrganisationTeamMemberMutation>;
export type DeleteOrganisationTeamMemberMutationResult = Apollo.MutationResult<DeleteOrganisationTeamMemberMutation>;
export type DeleteOrganisationTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationTeamMemberMutation, DeleteOrganisationTeamMemberMutationVariables>;